import { LOGGED_OFF } from './authentication';
import { POSTAL_CODE_API_KEY } from './settingsdata';
import CONFIG from '../config';

export const POSTAL_CODE_FETCHING = 'postaldata/fetching';
export const POSTAL_CODES_RETRIEVED = 'postaldata/retrieved';

const initialState = {
    fetchingData: false,
    postalCodes: null,
    municipalities: null,
};

// Groups the raw postal code entries (each carrying municipality_code / municipality_name)
// into a list of municipalities, each with the list of zip codes belonging to it.
export const buildMunicipalities = (codes) => {
    const byCode = new Map();
    (codes || []).forEach((entry) => {
        const code = entry.municipality_code;
        const name = entry.municipality_name;
        if (!code) return;
        if (!byCode.has(code)) {
            byCode.set(code, {
                municipalityCode: code,
                municipalityName: name,
                zipCodes: [],
            });
        }
        const municipality = byCode.get(code);
        if (entry.postal_code && !municipality.zipCodes.includes(entry.postal_code)) {
            municipality.zipCodes.push(entry.postal_code);
        }
    });
    return Array.from(byCode.values())
        .map((municipality) => ({
            ...municipality,
            zipCodes: municipality.zipCodes.sort((a, b) => parseInt(a, 10) - parseInt(b, 10)),
        }))
        .sort((a, b) => a.municipalityName.localeCompare(b.municipalityName, 'fi'));
};

export default (state = initialState, action) => {
    switch (action.type) {
        case POSTAL_CODE_FETCHING:
            return {
                ...state,
                fetchingData: true,
            };
        case POSTAL_CODES_RETRIEVED:
            return {
                postalCodes: action.codes.sort((a, b) => parseInt(a.postal_code) - parseInt(b.postal_code)),
                municipalities: buildMunicipalities(action.codes),
                fetchingData: false,
            };
        case LOGGED_OFF:
            return initialState;
        default:
            return state;
    }
};

export const getPostalCodes = () => {
    return async (dispatch) => {
        dispatch({
            type: POSTAL_CODE_FETCHING,
        });
        try {
            const resp = await fetch(CONFIG.postalCodeApiUrl, {
                method: 'GET',
                mode: 'cors',
                headers: {
                    'x-api-key': sessionStorage.getItem(POSTAL_CODE_API_KEY),
                },
            });
            const codes = await resp.json();
            dispatch({ type: POSTAL_CODES_RETRIEVED, codes });
        } catch (err) {
            console.log(err);
        }
    };
};
